import moment from "moment";
import React from "react";
import { TranferDateFormatter } from "../../../../helpers/helper";
import Images from "../../../UI/Images";

const CarrentDetail = ({ carRental }) => {
  return (
    <>
      <div className="row">
        <div className="col-lg-12 p-0">
          <div className="title">
            <h4>Car Booking Details</h4>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div>
            <h6>Tranfer Vehicle Details</h6>
            <div className="hotel-details-main">
              <div className="hotel-details-wrap d-flex align-items-center w-100">
                <div className="hotel-details-wrap-img">
                  <Images
                    img={carRental.carRent_master.image}
                    alter={"FlashLinks"}
                    dummy={"assets/images/dummyCar.png"}
                  />
                </div>
                <div className="hotel-details-wrap-star mt-0">
                  <p className="black-semi-14 mb-0">
                    {carRental.carRent_master.name}
                  </p>
                  <p className="blue-semi-12 m-0">
                    Reg. Number
                    <span className="black-medium-12 m-0">
                      : {carRental.carRent_master.registered_number}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="car-specifications">
            <h6>Car Specifications</h6>
            <div className="hotel-details-main">
              <div className="hotel-details-wrap d-flex align-items-center w-100 mb-4">
                <div className="hotel-details-wrap-img">
                  <img
                    src={carRental.carRent_master.cars_brand.image}
                    alt={carRental.carRent_master.cars_brand.name}
                  />
                </div>
                <div className="hotel-details-wrap-star mt-0">
                  <p className="black-semi-14 mb-0">
                    {carRental.carRent_master.cars_brand.name}
                    <span className="black-semi-14">
                      (Model - {carRental.carRent_master.model})
                    </span>
                  </p>
                </div>
              </div>
              <div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Fuel Type</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.fual_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Gear Type</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.gear_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Seat Capacity</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.seat_capacity}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Color</p>
                  <p className="black-medium-14 mb-0">
                    {" "}
                    {carRental.carRent_master.color}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Kilometers Driven</p>
                  <p className="black-medium-14 mb-0">
                    {" "}
                    {carRental.carRent_master.km_driven}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Hourly rate</p>
                  <p className="black-medium-14 mb-0">
                    ${carRental.carRent_master.hourly_rate}
                  </p>
                </div>

                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="driver-details">
            <h6>Driver Details</h6>
            <div className="hotel-details-main">
              <div className="driver-details-wrap">
                <div className="driver-details-img">
                  <img
                    src={carRental.driver_image}
                    alt={carRental.driver_name}
                  />
                </div>
                <div className="driver-details-content">
                  <p className="black-semi-14 mb-0">{carRental.driver_name}</p>
                  <div>
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        <img
                          src="./assets/images/phone-blue.svg"
                          alt="phone-blue"
                        />
                      </div>
                      <p className="black-medium-12 m-0">
                        {carRental.driver_contact}
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        <img
                          style={{ width: "15px" }}
                          src="./assets/images/email-blue.svg"
                          alt="email-blue"
                        />
                      </div>
                      <p className="black-medium-12 m-0">
                        {carRental.driver_email}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="driver-details">
            <h6>Description</h6>
            <div className="hotel-details-main">
              <p
                className="black-medium-12 mb-2"
                dangerouslySetInnerHTML={{
                  __html: carRental.carRent_master.detail,
                }}
              ></p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="driver-details">
            <h6>Payment Details</h6>

            <div className="hotel-details-main">
              <div className="hotel-details-wrap d-flex align-items-center w-100">
                <div className="hotel-details-wrap-star mt-0 d-flex align-items-center justify-content-between w-100 mb-4">
                  <div>
                    <p className="black-semi-14 mb-0">
                      {carRental.carRent_master.name}
                    </p>
                    <p className="blue-semi-12 m-0 mt-2">
                      Total hrs
                      <span className="black-medium-12 m-0">
                        :{carRental.journey_hours} * $
                        {carRental.carRent_master.hourly_rate}/hrs
                      </span>
                    </p>
                  </div>
                  <h5 className="black-semi-24">
                    $
                    {parseFloat(
                      carRental.journey_hours *
                        carRental.carRent_master.hourly_rate
                    )}
                  </h5>
                </div>
              </div>
              <p className="red-bg-text">
                <span className="d-block red-bold-14 mb-2">
                  Cancellation Policy
                </span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: carRental.carRent_master.cancellation_policy,
                  }}
                />
              </p>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <h6>Journey Details</h6>
              <h6>Journey Hours:{carRental.journey_hours}</h6>
            </div>
            <div className="hotel-details-main">
              <div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Fuel Type</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.fual_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Gear Type</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.gear_type}
                  </p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p className="black-semi-14 mb-0">Seat Capacity</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.luggage_capacity}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="black-semi-14 mb-0">Color</p>
                  <p className="black-medium-14 mb-0">
                    {carRental.carRent_master.color}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarrentDetail;

// const CarrentDetail = ({ carRental }) => {
//   return (
//     <>
//       <div>
//         <div className='my-trip-cancel'>
//           <div className='row cmn-box'>
//             <div className='col-lg-5'>
//               <div>
//                 <Images
//                   img={carRental.carRent_master.image}
//                   alter={"FlashLinks"}
//                   dummy={"assets/images/dummyCar.png"}
//                 />
//               </div>
//             </div>
//             <div className='col-lg-7'>
//               <div>
//                 <ul className='transfer-lists m-0 d-flex flex-wrap gap-4'>
//                   <li>
//                     {" "}
//                     Name :<p>{carRental.carRent_master.name}</p>
//                   </li>
//                   <li>
//                     Registered Number :
//                     <p>{carRental.carRent_master.registered_number}</p>
//                   </li>
//                   <li>
//                     Fuel Type :
//                     <div className='transfer-icon-wrap'>
//                       <img
//                         src='assets/images/car-rental/petrol.svg'
//                         alt='petrol'
//                       />
//                     </div>
//                     <p>{carRental.carRent_master.fual_type}</p>
//                   </li>
//                   <li>
//                     Gear Type :<p>{carRental.carRent_master.gear_type}</p>
//                   </li>
//                   <li>
//                     Seat Capacity :
//                     <div className='transfer-icon-wrap'>
//                       <img
//                         src='assets/images/car-rental/icon4.svg'
//                         alt='transfer'
//                       />
//                     </div>
//                     <p>{carRental.carRent_master.seat_capacity}</p>
//                   </li>
//                   <li>
//                     Luggage Capacity :
//                     <div className='transfer-icon-wrap'>
//                       <img
//                         src='assets/images/car-rental/luggage.svg'
//                         alt='transfer'
//                       />
//                     </div>
//                     <p>{carRental.carRent_master.luggage_capacity}</p>
//                   </li>
//                   <li>
//                     Color :<p>{carRental.carRent_master.color}</p>
//                   </li>
//                   <li>
//                     Model :<p>{carRental.carRent_master.model}</p>
//                   </li>
//                   <li>
//                     Hourly Rate :<p>{carRental.carRent_master.hourly_rate}</p>
//                   </li>
//                   <li>
//                     Type :<p>{carRental.carRent_master.cars_type.name}</p>
//                   </li>
//                   <li>
//                     Brand :
//                     <img
//                       src={carRental.carRent_master.cars_brand.image}
//                       style={{ height: "40px", width: "40px" }}
//                       alt='brand-image'
//                     />
//                     <p>{carRental.carRent_master.cars_brand.name}</p>
//                   </li>
//                   <li>
//                     Kilometers Driven :
//                     <p>{carRental.carRent_master.km_driven}</p>
//                   </li>
//                   <li>
//                     Highlight Title :
//                     <p>{carRental.carRent_master.highlight_title}</p>
//                   </li>
//                   <li>
//                     Included :<p>{carRental.carRent_master.included}</p>
//                   </li>
//                   <li>
//                     Detail :<p>{carRental.carRent_master.detail}</p>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           <div className='row cmn-box mt-4'>
//             <h3>
//               Total Payment : <i className='fa fa-dollar-sign'></i>
//               {carRental.total_payment}
//             </h3>
//             <h4>Cancellation Policy</h4>
//             <div
//               dangerouslySetInnerHTML={{
//                 __html: carRental.carRent_master.cancellation_policy,
//               }}
//             />
//           </div>
//           <div className='row cmn-box mt-4 w-25'>
//             <h3>Driver Details</h3>

//             <div className='row d-flex'>
//               <div className='col-md-3'>
//                 <img src={carRental.driver_image} alt='car-img' />
//               </div>
//               <div className='col-md-9'>
//                 <h5>Name : {carRental.driver_name}</h5>
//                 <h5>Email : {carRental.driver_email}</h5>
//                 <h5>Contact : {carRental.driver_contact}</h5>
//               </div>
//             </div>
//           </div>
//           <div className='cmn-box mt-4 w-25'>
//             <h3>Journey Details</h3>
//             <div className='row d-flex'>
//               <div className='col-md-3'>
//                 <img src={carRental.carRent_master.image} alt='car-img' />
//                 Map Here
//               </div>
//               <div className='col-md-9'>
//                 <p>
//                   Book Date :{" "}
//                   {moment(carRental.book_date).format("MMMM Do YYYY")}
//                 </p>
//                 <p>
//                   Drop Date :{" "}
//                   {moment(carRental.drop_date).format("MMMM Do YYYY")}
//                 </p>
//                 <p>
//                   Book Time :{" "}
//                   {carRental.book_time.split(":")[0] +
//                     ":" +
//                     carRental.book_time.split(":")[1]}
//                 </p>
//                 <p>
//                   Drop Time :{" "}
//                   {carRental.drop_time.split(":")[0] +
//                     ":" +
//                     carRental.drop_time.split(":")[1]}
//                 </p>
//               </div>
//               <div className=''>
//                 <h3>Journey Hours : {carRental.journey_hours}</h3>
//               </div>
//             </div>
//           </div>
//           {/*  */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CarrentDetail;
